var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-select",
        {
          staticClass: "mr-3",
          attrs: { placeholder: "選擇巡補員", clearable: "" },
          on: {
            clear: function ($event) {
              _vm._userId = null
              _vm.onSelect
            },
            change: _vm.onSelect,
          },
          model: {
            value: _vm._userId,
            callback: function ($$v) {
              _vm._userId = _vm._n($$v)
            },
            expression: "_userId",
          },
        },
        _vm._l(_vm.users, function (item) {
          return _c("el-option", {
            key: item.id,
            attrs: { label: _vm._f("formatUser")(item), value: item.id },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }